const OFFSET = 40;

/**
 * @param {HTMLElement} panel
 * @param {HTMLElement} summary
 */
function prePositionPanel(panel, summary) {
  const summaryRect = summary.getBoundingClientRect();
  panel.setAttribute('data-fixed-position', '');
  panel.style.top = `${summaryRect.bottom}px`;
  panel.style.left = `${summaryRect.left}px`;
}

/**
 * @param {HTMLElement} panel
 * @param {HTMLElement} summary
 */
function correctOverflow(panel, summary) {
  const summaryRect = summary.getBoundingClientRect();
  const rect = panel.getBoundingClientRect();
  const viewportWidth = window.innerWidth;
  if (rect.right > viewportWidth) {
    panel.style.left = `${summaryRect.left - (rect.right - viewportWidth) - OFFSET}px`;
  }
  if (rect.left < 0) {
    panel.style.left = `${OFFSET}px`;
  }
}

const section = document.querySelector('.section-program-materials-grid');

if (section) {
  // Pre-position BEFORE the details opens. click fires synchronously before the
  // browser processes the state change, so the panel is already at the right
  // position when it first becomes visible (toggle fires too late — as a task).
  section.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof HTMLElement)) return;
      const summary = event.target.closest('summary');
      if (!summary) return;
      const details = summary.parentElement;
      if (!(details instanceof HTMLDetailsElement) || !details.classList.contains('facets__panel')) return;
      if (details.open) return; // closing, not opening
      const panel = details.querySelector('floating-panel-component');
      if (!(panel instanceof HTMLElement)) return;
      prePositionPanel(panel, summary);
    },
    { capture: true }
  );

  // Correct horizontal overflow once the panel has real dimensions.
  section.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement) || !details.open) return;
      if (!details.classList.contains('facets__panel')) return;
      const panel = details.querySelector('floating-panel-component');
      const summary = details.querySelector(':scope > summary');
      if (!(panel instanceof HTMLElement) || !(summary instanceof HTMLElement)) return;
      requestAnimationFrame(() => correctOverflow(panel, summary));
    },
    { capture: true }
  );

  // Close any open filter panel when the user scrolls — panels are position:fixed
  // so their top/left don't track the page; closing is simpler than repositioning.
  window.addEventListener(
    'scroll',
    () => {
      const openPanel = section.querySelector('details.facets__panel[open]');
      if (openPanel instanceof HTMLDetailsElement) openPanel.open = false;
    },
    { passive: true }
  );

  // After a section re-render (e.g. #applyURLFiltersOnLoad), filter button labels
  // change to show active values (wider text). The overflow-list's internal
  // ResizeObserver won't fire because the host has a fixed container-driven width
  // (flex: 1 1 0). Dispatch a reflow event so it re-measures and shows MORE.
  // Only watches characterData/childList — not attributes — so slot reassignments
  // inside #reflowItems don't trigger this and cause a loop.
  const overflowList = section.querySelector('overflow-list.facets__overflow-list');
  if (overflowList instanceof HTMLElement) {
    let reflowScheduled = false;
    new MutationObserver(() => {
      if (reflowScheduled) return;
      reflowScheduled = true;
      requestAnimationFrame(() => {
        reflowScheduled = false;
        overflowList.dispatchEvent(new CustomEvent('reflow', { detail: {} }));
      });
    }).observe(overflowList, { subtree: true, childList: true, characterData: true });
  }

  // After a section re-render, morph removes data-fixed-position because it isn't
  // in the Shopify HTML. Re-apply position whenever the attribute disappears while
  // the panel is still open.
  new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      if (mutation.attributeName !== 'data-fixed-position') continue;
      const panel = mutation.target;
      if (!(panel instanceof HTMLElement) || panel.hasAttribute('data-fixed-position')) continue;
      const details = panel.closest('details.facets__panel');
      if (!(details instanceof HTMLDetailsElement) || !details.open) continue;
      const summary = details.querySelector(':scope > summary');
      if (!(summary instanceof HTMLElement)) continue;
      prePositionPanel(panel, summary);
      requestAnimationFrame(() => correctOverflow(panel, summary));
    }
  }).observe(section, { subtree: true, attributes: true, attributeFilter: ['data-fixed-position'] });
}
